export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

export const listTitle = [
    {
        title: 'Омниканальная система коммуникаций для Российского экспортного центра',
        subtitle:
            'Внедрили в&nbsp;работу Российского экспортного центра омниканальную систему маркетинговых коммуникации, которая позволяет автоматизировать взаимодействие с&nbsp;пользователями платформы &laquo;Мой экспорт&raquo;.',
        description: [
            {
                name: 'Отрасль',
                details: 'Внешнеэкономическая деятельность',
            },
            {
                name: 'Услуги',
                details: 'Разработка новых сервисов и&nbsp;техническая поддержка платформы',
            },
        ],
        company: 'Российский экспортный центр (РЭЦ)',
        companyLink: 'https://myexport.exportcenter.ru/',
        companyLinkName: 'myexport.exportcenter.ru',
        text:
            'Цифровая платформа &laquo;Мой экспорт&raquo;&nbsp;&mdash; единая информационная система с&nbsp;доступом к&nbsp;государственным и&nbsp;коммерческим услугам в&nbsp;области внешнеторговой деятельности. Платформа позволяет получить различные меры поддержки и&nbsp;услуги как потенциальным и&nbsp;начинающим экспортерам, так и&nbsp;экспортерам, имеющим опыт ведения внешнеэкономической деятельности. \n' +
            'Более 23&nbsp;тысяч компаний России зарегистрированы на&nbsp;платформе. РЭЦ нацелен на&nbsp;безбарьерные коммуникации со&nbsp;своими клиентами в&nbsp;формате одного окна.',
    },
];

export const listTarget = [
    {
        name: 'Цель',
        description:
            'Создать удобный инструмент для автоматического формирования персональных предложений для экспортеров на&nbsp;основе анализа их&nbsp;действий на&nbsp;платформе &laquo;Мой экспорт&raquo;',
    },
];

export const listCreateNumberProject = {
    title: 'Клиент определил следующие практические задачи, которые должна закрывать новая система:',
    list: [
        {
            numeric: '1.',
            text: 'Объединить коммуникации через электронную почту, сайт и&nbsp;текстовые сообщения.',
        },
        {
            numeric: '2.',
            text: 'Планировать и&nbsp;управлять кампаниями в&nbsp;соответствии с&nbsp;различными сценариями.',
        },
        {
            numeric: '3.',
            text: 'Формировать рассылки по&nbsp;разным сегментам целевой аудитории.',
        },
        {
            numeric: '4.',
            text: 'Создавать визуальные формы для каждого канала.',
        },
        {
            numeric: '5.',
            text: 'Управлять реакциями на&nbsp;различные действия получателей информации.',
        },
        {
            numeric: '6.',
            text: 'Агрегировать данные в&nbsp;единой базе.',
        },
        {
            numeric: '7.',
            text: 'Формировать отчеты по&nbsp;срезам.',
        },
    ],
};

export const listCreateDotProject = {
    title: 'Предпосылки создания проекта:',
    list: [
        {
            text: 'широкий перечень услуг и&nbsp;сервисов на&nbsp;платформе &laquo;Мой экспорт&raquo;;',
        },
        {
            text: 'большое количество плановых рекламных кампаний для экспортеров и&nbsp;потенциальных клиентов;',
        },
        {
            text: 'постоянное увеличение базы данных о&nbsp;поведенческих сценариях пользователей платформы;',
        },
        {
            text: 'рост затрат на&nbsp;настройку и&nbsp;реализацию маркетинговых кампаний.',
        },
    ],
};

export const listDescription = [
    {
        title: 'Описание проекта',
        text: [
            {
                paragraph:
                    'На&nbsp;крупных сайтах с&nbsp;большим перечнем разделов и&nbsp;пользовательских сервисов потеряться легко. Для улучшения пользовательского опыта и&nbsp;конверсии нужны подсказки, которые помогают найти нужную услугу, напоминают о&nbsp;том, что нужно вернуться к&nbsp;заполнению заявки, позволяют задать вопрос консультанту или по&nbsp;электронной почте сообщают о&nbsp;персональных предложениях.',
            },
            {
                paragraph:
                    'Команда РЭЦ решила аккумулировать информацию и&nbsp;историю взаимодействия с&nbsp;пользователями платформы &laquo;Мой экспорт&raquo; и&nbsp;автоматизировать коммуникации с&nbsp;целевой аудиторией. Для этих задач решили создать собственный сервис с&nbsp;омниканальной архитектурой. Внедрение этой системы также должно сократить повторяющиеся ручные настройки, высвободить время специалистов, увеличить скорость и&nbsp;эффективность коммуникации за&nbsp;счет целенаправленного контента на&nbsp;основе цифрового следа пользователя.',
            },
        ],
        description:
            'Омниканальный подход улучшает сервис, помогает клиентам найти нужные им&nbsp;услуги и&nbsp;обеспечивает постоянную связь.',
    },
];

export const listDescriptionBd = [
    {
        title: 'Кастомизация продукта и&nbsp;расширение функционала',
        name: 'Миграция базы данных:',
        text: [
            {
                paragraph:
                    'В&nbsp;архитектуру ИТ-решения, которая строилась в&nbsp;соответствии с&nbsp;жесткими требованиями архитекторов заказчика, был заложен перенос Mautic с&nbsp;MySQL в&nbsp;СУБД клиента. Для этой задачи воспользовались своим опытом портирования решений в&nbsp;среду СУБД клиента. Также нам помогло&nbsp;то, что большая часть кода написана на&nbsp;популярной ORM, которая нивелировала разницу между базами данных в&nbsp;большинстве случаев.',
            },
            {
                paragraph:
                    'В&nbsp;итоге мы&nbsp;успешно адаптировали Mautic, стараясь минимально вносить изменения в&nbsp;исходный код для простой совместимости при загрузке обновлений из&nbsp;репозитория сообщества.',
            },
        ],
    },
];

export const listDescriptionProcess = [
    {
        title: 'Процесс',
        name: 'Анализ и выбор решения',
        text: [
            {
                paragraph:
                    'На&nbsp;первом этапе провели анализ клиентского запроса, технических требований по&nbsp;проекту. Для этого потребовалось несколько дополнительных встреч с&nbsp;заказчиком, чтобы понять бизнес-цели или боли, которые надо решить. Собрали все пожелания по&nbsp;финальному результату и&nbsp;добавили их&nbsp;в&nbsp;итоговое техническое задание с&nbsp;учетом наших бизнес-процессов. Этот процесс занял у&nbsp;команды 2&nbsp;недели.',
            },
            {
                paragraph:
                    'Следующий шаг&nbsp;&mdash; выбор решения. Для целей клиента проанализировали плюсы и&nbsp;минусы 8&nbsp;разных систем, соотнесли их&nbsp;с&nbsp;требованиями и&nbsp;в&nbsp;итоге остановились на&nbsp;Mautiс. Это один из&nbsp;лучших ИТ-продуктов с&nbsp;открытым кодом, который имеет положительный опыт более 200+ тысяч внедрений во&nbsp;всем мире.',
            },
        ],
        description: 'ИТ-продукт с&nbsp;положительным опытом 200+ внедрений во&nbsp;всем мире',
        icon: '/images/pic/new-rec/mautic.jpg',
        imgName: 'Mautic',
    },
];

export const listCreateDotProjectProcessPlus = {
    subtitle: 'Плюсы выбранного ИТ-продукта',
    list: [
        {
            text: 'размещение на&nbsp;нашем собственном сервере;',
        },
        {
            text: 'широкий функционал из&nbsp;коробки, который закрывает большую часть требований по&nbsp;проекту;',
        },
        {
            text: 'масштабируемость под любую сферу деятельности;',
        },
        {
            text: 'гибкость и&nbsp;независимость, которую дает открытый код;',
        },
        {
            text: 'совместимость с&nbsp;PHP и&nbsp;Symfony;',
        },
        {
            text: 'большое активное сообщество и&nbsp;публичный roadmap развития.',
        },
    ],
};

export const listCreateDotProjectProcessMinus = {
    subtitle: 'Основные минусы',
    list: [
        {
            text: 'нужно адаптировать с&nbsp;системой оркестрации клиента;',
        },
        {
            text: 'не&nbsp;совместим с&nbsp;системой управления базами данных клиента.',
        },
    ],
};

export const listDescriptionSecurity = [
    {
        name: 'Высокие требования к&nbsp;безопасности налагают ограничения на&nbsp;разработку',
        text: [
            {
                paragraph:
                    'У&nbsp;заказчика строгий SSDL-процесс, который не&nbsp;позволяет делать релизы быстро. Любое обновление проходит ревью нескольких отделов. Это мотивировало нас делать меньше релизов и&nbsp;включать в&nbsp;них максимально все доработки, так как цена ошибки слишком велика относительно времени.',
            },
            {
                paragraph:
                    'У&nbsp;команды не&nbsp;было доступа к&nbsp;контурам старше dev-стенда. Это заставило нас продумывать глубокую иерархию логов в&nbsp;корпоративной системе логирования. Также мы&nbsp;интегрировали сервис отслеживания инцидентов в&nbsp;коде для более быстрой диагностики падений. Чтобы уменьшить количество релизов настройки системы оркестрации, сначала тестировали все функции и&nbsp;обновления на&nbsp;своем кластере, который подняли для этих целей. Уже обкатанные настройки вносили в&nbsp;кластер клиента. Аналогичным образом поступили и&nbsp;с&nbsp;мониторингом на&nbsp;стандартном для системы оркестрации стеке.',
            },
            {
                paragraph:
                    'Любой пакет обновлений проходил ревью и&nbsp;публиковался в&nbsp;корпоративном хранилище пакетов. Почистили зависимости, которые для Mautic не&nbsp;так уж&nbsp;сильно и&nbsp;нужны. Любое внешнее обращение резалось строгими сетевыми политиками&nbsp;ПО службы безопасности. WAF-политики также вмешивались в&nbsp;работу приложения и&nbsp;ломали&nbsp;ее. Провели ряд итераций с&nbsp;адаптацией WAF-политик под конкретную систему.',
            },
            {
                paragraph:
                    'Для публикации API использовали API Managment System, которая позволяет лучше управлять жизненным циклом API продукта и&nbsp;улучшить контроль использования API.',
            },
        ],
        description:
            'Любое обновление проходило многоступенчатое согласование, поэтому в&nbsp;каждый релиз включали все доработки, которые предварительно тестировали на&nbsp;своем кластере',
    },
];

export const listDescriptionRoles = [
    {
        name: 'Интеграция с&nbsp;системой SSO заказчика и&nbsp;настройка ролей',
        text: [
            {
                paragraph:
                    'Систему единого входа писал другой подрядчик, и&nbsp;в&nbsp;ней была заявлена поддержка открытого SSO-протокола. К&nbsp;моменту нашего подключения, она еще не&nbsp;тестировалась. Дописали блок авторизации через протокол. Для простоты отладки в&nbsp;локальном стеке развернули keycloack для замены сервера авторизации в&nbsp;локальном окружении. В&nbsp;среде заказчика обозначили ряд несоответствий стандартам протокола, которые устранял предыдущий подрядчик в&nbsp;тесном контакте с&nbsp;нами.',
            },
            {
                paragraph:
                    'Внутри личного кабинета нового сервиса есть разграничение ролей по&nbsp;уровню доступа для настройки рассылок, построения цепочек и&nbsp;сценариев. Это позволяет распределять задачи и&nbsp;ответственность внутри команды, избежать дублирования работы и&nbsp;повысить прозрачность процессов.',
            },
        ],
    },
];

export const listDescriptionAnalytic = [
    {
        name: 'Аналитика кампаний',
        text: [
            {
                paragraph:
                    'Автоматизация маркетинга требует постоянной обратной связи. При запуске кампании необходимо знать, что работает, а&nbsp;что нет, чтобы внести исправления. В&nbsp;этом помогают отчеты. В&nbsp;стандартной версии Mautic есть статистика по&nbsp;посетителям, сбор ответов на&nbsp;формы. Для национальной экспортной платформы этого недостаточно.',
            },
            {
                paragraph:
                    'Наши разработчики создали несколько сложных конструкторов для построения отчетности по&nbsp;нескольким срезам, добавили фильтры, чтобы сегментировать статистику по&nbsp;различным критериям. Также расширили количество форматов для выгрузки отчетов.',
            },
        ],
        description:
            'Разработали и&nbsp;внедрили несколько конструкторов для построения аналитики по&nbsp;сегментам, используя различные фильтры',
    },
];

export const listDescriptionProcessDev = [
    {
        name: 'Разработка технической документации',
        text: [
            {
                paragraph:
                    'Перед тем, как приступить к&nbsp;доработке опенсорсного продукта, разработать новые блоки и&nbsp;развернуть эту новую систему в&nbsp;пространстве клиента, наша команда аналитиков прописала всю архитектуру проекта в&nbsp;документах. Это позволило минимизировать сроки и&nbsp;добиться максимальной эффективности.&nbsp;до&nbsp;начала разработки.',
            },
        ],
    },
];

export const listDescriptionResult = [
    {
        title: 'Результаты',
        text: [
            {
                paragraph:
                    'Для Российского экспортного центра разработали инструмент, который позволяет автоматизировать базовые сценарии взаимодействия с&nbsp;пользователями платформы &laquo;Мой экспорт&raquo; и&nbsp;существенно сократить трудовые и&nbsp;финансовые затраты на&nbsp;коммуникацию с&nbsp;пользователями.',
            },
            {
                paragraph:
                    'Сервис находится на&nbsp;этапе бета-тестирования, но&nbsp;уже можно сказать, что он&nbsp;максимально соответствует тем целям, которые первоначально были заложены в&nbsp;проект. Это автоматизация ряда задач, увеличение скорости коммуникации и&nbsp;омниканальный подход к&nbsp;взаимодействию с&nbsp;клиентами.',
            },
            {
                paragraph:
                    'Этот эффект достигается за&nbsp;счет использования уже имеющихся поведенческих данных и&nbsp;маркетинговых опций системы. Сервис также позволяет планировать рассылки через разные каналы взаимодействия, обеспечивая непрерывность и&nbsp;&laquo;бесшовность&raquo; коммуникаций.',
            },
        ],
    },
];

export const listResultInfoDev = {
    title: 'Разработаны документы:',
    items: [
        {
            icon: '/images/svg/new-rec/6.svg',
            name: 'Программа и&nbsp;методика испытаний',
        },
        {
            icon: '/images/svg/new-rec/7.svg',
            name: 'Программа опытной эксплуатации',
        },
        {
            icon: '/images/svg/new-rec/8.svg',
            name: 'Руководство администратора и&nbsp;пользователя',
        },
        {
            icon: '/images/svg/new-rec/9.svg',
            name: 'Спецификация требований программного обеспечения',
        },
        {
            icon: '/images/svg/new-rec/10.svg',
            name: 'Пояснительная записка к&nbsp;техническому проекту',
        },
        {
            icon: '/images/svg/new-rec/11.svg',
            name: 'Ролевая модель',
        },
    ],
    text: 'После опытной эксплуатации системы и&nbsp;приемочных испытаний библиотека проекта пополнилась журналом опытной эксплуатации, методикой нагрузочного тестирования, паспортом информационной системы, отчетом о&nbsp;проведении нагрузочного тестирования.',
};

export const listDefaultBlock = {
    title: 'Портирование решения в&nbsp;систему оркестрации',
    textTop:
        'Еще один вызов&nbsp;&mdash; адаптировать решение к&nbsp;среде оркестратора клиента. У&nbsp;заказчика высокие требования к&nbsp;качеству кластеризации, которые, например, запрещают монтирование томов.',
    description:
        '&laquo;В&nbsp;проекте для РЭЦ портирование прошло относительно гладко за&nbsp;исключением задач Cron. Помог наш опыт <a href="https://webpractik.ru/cases/development/pochtabank" target="_blank">адаптации PHP-приложений под k8s.</a> Следуя архитектуре k8s, мы&nbsp;портировали задачи в&nbsp;Cron Job. Но&nbsp;их&nbsp;оказалось слишком много, более 30&nbsp;штук. Решили сгруппировать мелкие задачи в&nbsp;другом планировщике и&nbsp;запустили их&nbsp;в&nbsp;отдельный запрос. Крупные задачи оставили в&nbsp;Cron&raquo;',
    name: 'Иван Поддубный',
    img: '/images/pic/new-rec/ivan.png',
    position: 'СТО агентства «Вебпрактик»',
    textBottom:
        'Также для портирования в&nbsp;систему оркестрации клиента понадобилось вынести рассылку писем. Изначально по&nbsp;архитектуре очередь сообщений строится на&nbsp;файлах. Мы&nbsp;предложили вынести все в&nbsp;отдельный демон и&nbsp;подключить систему очередей для обработки запросов.',
};

export const listResultInfo = {
    title: 'Команда &laquo;Вебпрактик&raquo; создала уникальную систему омниканальных коммуникаций с&nbsp;массой возможностей, которых не&nbsp;было в&nbsp;первоначальном базовом ИТ-решении:',
    items: [
        {
            icon: '/images/svg/new-rec/1.svg',
            name: 'Сегментированный анализ действий посетителей сайта РЭЦ',
        },
        {
            icon: '/images/svg/new-rec/2.svg',
            name: 'Автоматизация рассылок по&nbsp;цифровым каналам',
            description: 'электронная почта и&nbsp;браузерные push-уведомления',
        },
        {
            icon: '/images/svg/new-rec/3.svg',
            name: 'Персонализация контента для потенциальных экспортеров и&nbsp;участников ВЭД',
        },
        {
            icon: '/images/svg/new-rec/4.svg',
            name: 'Создание автоматических цепочек рассылок',
        },
        {
            icon: '/images/svg/new-rec/5.svg',
            name: 'Отчётность по&nbsp;маркетинговым кампаниям',
        },
    ],
};

export const listIntegration = {
    title: 'Интеграция с системой управления справочными данными',
    description: 'Реализовали интеграцию с&nbsp;помощью двух механизмов:',
    list: [
        {
            numeric: '1.',
            text: 'Через сервис очередей в&nbsp;онлайн-режиме, что позволяет решению максимально быстро подхватить появление новых пользователей и&nbsp;передать их&nbsp;данные в&nbsp;общую клиентскую базу.',
        },
        {
            numeric: '2.',
            text: 'Массовая синхронизация через промежуточную витрину данных.',
        },
    ],
};

export const listMarketing = {
    title: 'Пример построения маркетинговой кампании с&nbsp;разными условиями',
    description:
        'Пользователь авторизовался на&nbsp;&laquo;Мой Экспорт&raquo; и&nbsp;начал заполнять заявку на&nbsp;услугу, но&nbsp;не&nbsp;завершил процесс оформления. Услуга перешла в&nbsp;статус &laquo;Черновик&raquo;. Данные о&nbsp;статусе услуги переданы в&nbsp;ОСУМК. Такая ситуация повторяется неоднократно. Для напоминания пользователям о&nbsp;завершении оформления услуги, построена маркетинговая кампания. При наступлении определенных условий система автоматически отправляет письмо с&nbsp;выбранным шаблоном и&nbsp;подстановкой пользовательских данных. <br/><br/> Есть два варианта развития ситуации.',
    list: [
        {
            numeric: '1.',
            subtitle: 'Статус оформленной услуги изменился',
            text: 'В&nbsp;течение N&nbsp;часов клиент вернулся на&nbsp;портал и&nbsp;оформил услугу. В&nbsp;соответствии с&nbsp;BPMN-процессом кампания завершает работу.',
        },
        {
            numeric: '2.',
            subtitle: 'Статус оформленной услуги не&nbsp;изменился',
            text: 'Через N&nbsp;часов услуга все еще в&nbsp;статусе &laquo;Черновик&raquo;. Отправляется письмо с&nbsp;напоминанием. Пользователь переходит из&nbsp;письма в&nbsp;личный кабинет на&nbsp;портале и&nbsp;продолжает оформление услуги. Статус изменился на&nbsp;следующий (не &laquo;Черновик&raquo;). В&nbsp;соответствии с&nbsp;BPMN-процессом кампания завершает работу.',
        },
    ],
    picture: '/images/pic/new-rec/marketing.gif',
};

export const listCompanies = {
    title: 'Построение пилотных кампаний',
    description:
        'Благодаря объемной базе данных о&nbsp;пользовательском опыте, которая аккумулируется в&nbsp;системе, можно создавать различные маркетинговые кампании с&nbsp;учетом бизнес-задач и&nbsp;на&nbsp;основе особенностей поведения и&nbsp;профиля каждого контакта. <br/><br/>Кампания&nbsp;&mdash; это маркетинговое мероприятие для определенной целевой аудитории с&nbsp;четким продуктовым посылом для достижения одной конкретной цели. Коммуникация в&nbsp;рамках кампании выстраивается по&nbsp;одному выбранному или нескольким каналам: электронная почта, push-уведомления, мессенджеры, или создается цепочку, используя несколько точек касания. Так достигается омниканальность.',
    // picture: companies,
};

export const listRec = {
    title: 'Пример построения персонализованного контента на&nbsp;сайте РЭЦ на&nbsp;основании поведения пользователя',
    description:
        'Персональный контент управляется через условия и&nbsp;действия маркетинговых кампаний в&nbsp;зависимости от&nbsp;пользовательского поведения на&nbsp;сайте.',
    list: [
        {
            numeric: '1.',
            text: 'Пользователь зарегистрировался на сайте, система идентифицировала его как «нового пользователя» и создает о нем запись. На главной странице размещается контент без персонализации.',
        },
    ],
    secondList: [
        {
            numeric: '2.',
            text: 'Действия пользователя на&nbsp;сайте (просмотр страниц и&nbsp;услуг) фиксируются системой.',
        },
        {
            numeric: '3.',
            text: 'На&nbsp;основе поведения пользователя система проводит сегментацию посетителей и&nbsp;отправляет на&nbsp;&laquo;Мой экспорт&raquo; запрос на&nbsp;отображение персонализированного контента в&nbsp;специально отведенных для этого блоках.',
        },
        {
            numeric: '4.',
            text: 'При обновлении страниц сайта пользователю отображается персональный контент.',
        },
    ],
    picture: '/images/pic/new-rec/banner.jpg',
    secondPicture: '/images/pic/new-rec/popular.jpg',
    thirdPicture: '/images/pic/new-rec/graphic.jpg',
};

export const listDescriptionContent = [
    {
        name: 'Глубокая персонализация контента сайта',
        text: [
            {
                paragraph:
                    'На&nbsp;сайт интегрировали подбор персонализированных услуг, баннеров, слайдеров и&nbsp;других форматов, которые позволяют показывать посетителям уникальный контент и&nbsp;набор услуг в&nbsp;соответствии с&nbsp;их&nbsp;пользовательским опытом. Специальный счетчик собирает метрики на&nbsp;сайте myexport.exportcenter.ru, запоминая действия пользователей.',
            },
            {
                paragraph:
                    'На&nbsp;основе такого анализа сервис позволяет персонализировать контент на&nbsp;сайте под профиль пользователя в&nbsp;соответствии с&nbsp;его запросами.',
            },
        ],
        description:
            'Система персонализирует контент на&nbsp;сайте под профиль пользователя в&nbsp;соответствии с&nbsp;его запросами',
    },
];

export const listDescriptionMarketing = [
    {
        text: [
            {
                paragraph:
                    'Автоматизация маркетинга&nbsp;&mdash; непростая задача. Поэтому мы&nbsp;помогаем своим клиентам и&nbsp;консультируем их&nbsp;на&nbsp;этапе тестирования и&nbsp;опытной эксплуатации. Вместе с&nbsp;командой РЭЦ прошли путь создания нескольких типов рассылок по&nbsp;ключевым поведенческим сценариям.',
            },
            {
                paragraph:
                    'Прописали шаги по&nbsp;клиентской воронке и&nbsp;создали несколько сценариев, предусмотрев коммуникацию в&nbsp;разных каналах и&nbsp;с&nbsp;несколькими касаниями. В&nbsp;визуальном конструкторе сделали макет рассылки по&nbsp;электронной почте, не&nbsp;требующий HTML. Также настроили запуск push-уведомлений на&nbsp;сайте для определенного сегмента пользователей и&nbsp;подгрузили выбранный шаблон сообщения.',
            },
            {
                paragraph:
                    'Внутри системы можно редактировать свои кампании, менять настройки запусков, прописывать различные условия для запуска кампаний и&nbsp;формировать сегменты получателей. Сервис может тиражировать рассылку для групп пользователей или отправлять персональные сообщения. Для планирования кампаний с&nbsp;нуля разработали блок &laquo;Календарь&raquo; с&nbsp;функциями отложенных рассылок.',
            },
            {
                paragraph:
                    'Автоматизация сводит к&nbsp;минимуму количество времени, необходимое для ручного управления контактами, увеличивает эффективность взаимодействия с&nbsp;целевой аудиторией и&nbsp;повышает надежность проведения маркетинговых кампаний.',
            },
        ],
        description:
            'Рассылки и&nbsp;сообщения отправляются автоматически в&nbsp;соответствии с&nbsp;набором инструкций',
    },
];

export const listTeam = [
    {
        title: 'Команда',
        members: [
            {
                name: 'Татьяна Головко',
                position: 'Менеджер проекта',
            },
            {
                name: 'Иван Поддубный',
                position: 'CTO',
            },
            {
                name: 'Александр Забанов',
                position: 'Backend-техлид',
            },
            {
                name: '3 бизнес-аналитика',
            },
            {
                name: '2 backend-разработчика',
            },
            {
                name: '1 frontend-разработчик',
            },
            {
                name: '1 DevOps-инженер',
            },
            {
                name: '2 QA-инженера',
            },
            {
                name: '1 ассистент менеджера',
            },
        ],
    },
];
